module.exports = __webpack_public_path__ + "static/media/close_icon.55a5ef94.svg";